var _circle, _path, _path2, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloggerSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.9 473.9",
    style: {
      enableBackground: "new 0 0 473.9 473.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "face",
    className: "face",
    cx: 237,
    cy: 237,
    r: 237
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mouth",
    className: "mouth_alt",
    d: "M81.4,237.1C81.4,323,151,392.7,237,392.7c85.9,0,155.6-69.6,155.6-155.6L81.4,237.1L81.4,237.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "tounge",
    className: "tounge",
    d: "M150.5,298.7c0,47.8,38.7,86.5,86.5,86.5c47.8,0,86.5-38.7,86.5-86.5L150.5,298.7L150.5,298.7z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "left-eye",
    className: "eye squished--eye",
    cx: 164.9,
    cy: 155.2,
    r: 37.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "right-eye",
    className: "eye squished--eye",
    cx: 305.7,
    cy: 155.2,
    r: 37.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloggerSmiley);
export default __webpack_public_path__ + "static/media/blogger-smiley.0e1245b3.svg";
export { ForwardRef as ReactComponent };